/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 账户管理 */
  GetList: RootPath + 'plugin/websys/core/user/GetList',
  Update: RootPath + 'plugin/websys/core/user/Update'
}


export default apis